import clsx from "clsx";

import classes from "./styles.module.scss";

import type { IAudioViewerProps } from ".";

import { CustomAudioPlayer } from "@components/atoms/audioPlayer";

export function AudioViewer({ src }: IAudioViewerProps) {
  return (
    <div className={clsx(classes.audioViewer)}>
      <CustomAudioPlayer src={src} />
    </div>
  );
}
